import React, { useRef, useState } from 'react'
import { Box, Tooltip } from '@mui/material'

import { DefaultOrgIcon } from '~assets/icons'
import { typography } from '~tokens/internal'

import Avatar from '../Avatar'
import Typography from '../Typography'

import './OrganizationChip.scss'

interface OrganizationChipProps {
  orgName: string
  orgIcon?: string
  outlined?: boolean
  size?: 'small' | 'medium'
}

const OrganizationChip: React.FC<OrganizationChipProps> = ({
  orgName,
  orgIcon,
  outlined = true,
  size = 'small',
}) => {
  const chipRef = useRef<HTMLDivElement>(null)
  const [isTruncated, setIsTruncated] = useState(false)

  const updateTruncation = (): void => {
    const label = chipRef.current?.querySelector<HTMLElement>('.MuiTypography-root')
    setIsTruncated(!!label && label.scrollWidth > label.clientWidth)
  }

  if (size === 'medium') {
    return (
      <Tooltip title={isTruncated ? orgName : ''}>
        <Box
          ref={chipRef}
          className='organization-chip organization-chip--medium'
          onMouseEnter={updateTruncation}
          onFocus={updateTruncation}
        >
          {orgIcon ? (
            <Avatar size='sm' src={orgIcon} alt={orgName} />
          ) : (
            <DefaultOrgIcon width={20} height={20} />
          )}
          <Typography component='span' variant='body2' color='textPrimary'>
            {orgName}
          </Typography>
        </Box>
      </Tooltip>
    )
  }

  return (
    <Box className={`organization-chip ${outlined ? 'organization-chip--outlined' : ''}`}>
      {orgIcon ? (
        <Avatar size='xs' src={orgIcon} alt={orgName} />
      ) : (
        <DefaultOrgIcon width={typography.fontSizePx.sm} height={typography.fontSizePx.sm} />
      )}
      <Typography component='span' variant={outlined ? 'body2' : 'body1'} color='textSecondary'>
        {orgName}
      </Typography>
    </Box>
  )
}

export default OrganizationChip
